import { render, staticRenderFns } from "./allTenantSwitch.vue?vue&type=template&id=16bc76b4&scoped=true&"
import script from "./allTenantSwitch.vue?vue&type=script&lang=js&"
export * from "./allTenantSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bc76b4",
  null
  
)

export default component.exports